export const getEntryGroupId = (url: string) => {
  //prefixes: ['gradoo://', 'https://gradoo.app'],
  //gradoo://group/:gid  [ 'gradoo:', '', 'group', 'group_1', 'team', 'team_1' ]
  //https://gradoo.app/group/:gid [ 'https:', '', 'gradoo.app', 'group', 'group_1', 'team', 'team_1' ]
  const pathIndex = url.includes('gradoo://') ? 3 : 4;
  const idParam = url.split('/')?.[pathIndex];
  return decodeURIComponent(idParam);
};
